import { Component, OnInit, Input } from '@angular/core';
import { Offerte } from '../model/offerte';

@Component({
  selector: 'app-offerta-min-foto',
  templateUrl: './offerta-min-foto.component.html',
  styleUrls: ['./offerta-min-foto.component.scss']
})
export class OffertaMinFotoComponent implements OnInit {

  constructor() { }
  @Input () offerta:Offerte ;
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/offerta-min-foto/offerta-min-foto.component.ts